import NavBar from "../../components/NavBar.vue";
import SideBar from "../../components/SideBar.vue";

export default {
  name: "DefaultContainer",
  components: { NavBar, SideBar },
};